import { AppBarDataCustomItem } from '@ihsm/ui-shared';
import { ColumnCategory } from 'services/types';
import { ReportGroupItem } from 'shared/types';
import { BenchmarkDropdown } from '../components/BenchmarkDropdown';
import { ValuationDatePicker } from '../components/ValuationDatePicker';

export const rowHeader = { name: 'rowId', title: 'Name' };

export const TRADE_ID_GROUP: ReportGroupItem = {
  name: 'TradeId',
  category: 'Ref Data',
};

export const TABS_COLUMN_OPTIONS: ColumnCategory[] = [
  'Ref Data',
  'Pricing',
  'Sensitivity',
  'VaR',
  'Stress Test',
];

export const REPORT_TYPE_OPTIONS = ['Custom'];

export const BENCH_OPTION: AppBarDataCustomItem = {
  key: 'benchmark',
  type: 'customOption',
  component: BenchmarkDropdown,
};

export const DATE_OPTION: AppBarDataCustomItem = {
  key: 'date',
  type: 'customOption',
  component: ValuationDatePicker,
};
